module.exports = __webpack_public_path__ + "files/c8a7c9a1cb0f5432a610e6d087d547df.png";